import React from 'react';
import Dashboard from './Page/Dashboard/Dashboard';

function App() {
  return (
    <div className="App bg-white ">
      <Dashboard></Dashboard>    
    </div>
  );
}

export default App;
